import * as React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { HomePage } from './components/pages/HomePage';
import { ResultPage } from './components/pages/ResultPage';
import { QuestionnairePage } from 'components/pages/QuestionnairePage';
import { QuestionnaireProvider } from 'contexts/QuestionnaireContext';
import QuestionnaireListPage from 'components/pages/QuestionnaireListPage';
import { QuestionnaireStartPage } from 'components/pages/QuestionnaireStartPage';
import ScrollToTop from 'components/common/ScrollToTop';
import { ShareView } from 'components/views/ShareView';


export const routes = (
	<React.Fragment>
		<ScrollToTop/>
		<Switch>
			<Route exact path='/' component={HomePage} />
			<Route path='/questionnaire'>
				<QuestionnaireProvider>
					<Switch>
						<Route exact path='/questionnaire' component={QuestionnaireListPage} />
						<Route exact path='/questionnaire/:id' component={QuestionnaireStartPage} />
						<Route exact path='/questionnaire/:id/result' component={ShareView} />
						<Route path='/questionnaire/:id' component={QuestionnairePage} />
					</Switch>
				</QuestionnaireProvider>
			</Route>
			<Route path='/result/:code' component={ResultPage} />
			<Route path='/'>
				<Redirect to='/' />
			</Route>
		</Switch>
	</React.Fragment>
);